import 'owl.carousel';

const $el = $('.js-trustpilot');

$el.owlCarousel({
    loop: true,
    dots: false,
    mouseDrag: true,
    nav: true,
    navText: [],
    responsive: {
        0: {
            center: true,
            items: 1,
            stagePadding: 20,
        },
        850: {
            items: 2,
            stagePadding: 60,
        },
        1100: {
            items: 3,
            stagePadding: 60,
        },
        1500: {
            items: 4,
            stagePadding: 60,
        },
    },
});

$el.on('click', '.owl-item', function () {

    const $slide = $(this);

    if ($slide.hasClass('active')) {
        return;
    }

    // If next slide has active class we're user has clicked far left slide
    if ($slide.next().hasClass('active')) {
        $el.trigger('prev.owl.carousel');
    } else {
        $el.trigger('next.owl.carousel');
    }

});

$el.find('.js-toggle-full-quote').on('click', function () {
    $(this)
        .parents('.js-truncated-quote')
        .addClass('hidden')
        .siblings('.js-full-quote')
        .removeClass('hidden');
});

$el.on('changed.owl.carousel', () => {
    dataLayer.push({
        event: 'browseTestimonials',
    });
});

// Disable links for off screen items
$('.js-trustpilot-item').on('click', (e) => {
    e.preventDefault();
    if ($(e.currentTarget).closest('.owl-item').hasClass('active')) {
        window.open(e.currentTarget.href, '_blank');
    }
});
